import { useQuery } from '@tanstack/react-query';
import { ctcApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Great Plains (CTC) jobs that have been closed. */
export function useClosedCtcJobs() {
  return useQuery({
    queryKey: queryKeys.ctc.closed(),
    queryFn: ({ signal }) => ctcApiClient.listClosedCTC(toCancelToken(signal)),
    staleTime: 5 * 60_000,
    meta: { errorContext: 'closed CTC jobs' },
  });
}
